var render = function render(_c, _vm) {
  return _c(
    "div",
    {
      class: [
        _vm.$style.align,
        _vm.props.left && _vm.$style.left,
        _vm.props.right && _vm.$style.right,
        _vm.props.center && _vm.$style.center,
        _vm.props.spaceBetween && _vm.$style.spaceBetween,
        _vm.props.ignoreChildren && _vm.$style.ignoreChildren,
      ],
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }